// extracted by mini-css-extract-plugin
export default {"root":"twvZJLW3","scale":"ycWeuIj6"};